import styled from 'styled-components'
import { colors } from 'client/styles'
import TooltipIcon from 'client/icons/Info'

export const FilterFamilyBase = styled.div`
  padding-block: 15px;
  padding-inline: 20px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-block-end: 1em;
`

export const Title = styled.h3`
  color: ${colors.grey1};
  font-weight: 700;
`

export const IconInfo = styled(TooltipIcon)`
  fill: ${colors.grey2};
  margin-block: 0;
  margin-inline: 10px;
`
